export default __webpack_public_path__ + "static/style-75f025319c057eae22f1c5b56818acde.png";